import moment from "moment-timezone";

export const breakdownByCalendar = (targetMoment, nowMoment) => {
  const clampNonNeg = (n) => Math.max(n, 0);

  // Both moments should already be in the same timezone
  let months = clampNonNeg(targetMoment.diff(nowMoment, "months"));
  let cursor = nowMoment.clone().add(months, "months");

  let weeks = clampNonNeg(targetMoment.diff(cursor, "weeks"));
  cursor = cursor.add(weeks, "weeks");

  let days = clampNonNeg(targetMoment.diff(cursor, "days"));
  cursor = cursor.add(days, "days");

  let hours = clampNonNeg(targetMoment.diff(cursor, "hours"));
  cursor = cursor.add(hours, "hours");

  let minutes = clampNonNeg(targetMoment.diff(cursor, "minutes"));
  cursor = cursor.add(minutes, "minutes");

  let seconds = clampNonNeg(targetMoment.diff(cursor, "seconds"));

  return { months, weeks, days, hours, minutes, seconds };
};

export const toMomentInUserTz = (value) => {
  const userTz = moment.tz.guess();

  if (moment.isMoment(value)) return value.clone().tz(userTz);

  if (moment.isDuration(value)) {
    // If it's a duration, calculate the target time from now
    const now = moment.tz(userTz);
    return now.clone().add(value);
  }

  if (value instanceof Date) return moment.tz(value, userTz);

  if (typeof value === "number") {
    const y = Math.trunc(value);
    return moment.tz(`${y}-01-01T00:00:00`, userTz);
  }

  if (typeof value === "string") {
    const s = value.trim();

    if (/^\d{4}$/.test(s)) {
      return moment.tz(`${s}-01-01T00:00:00`, userTz);
    }

    if (/^\d{4}-\d{2}$/.test(s)) {
      return moment.tz(`${s}-01T00:00:00`, userTz);
    }

    return moment.tz(s, userTz);
  }

  // Default: midnight January 1st of next year in user's timezone
  const nextYear = moment().year() + 1;
  return moment.tz(`${nextYear}-01-01T00:00:00`, userTz);
};

// Keep old name as alias for backwards compatibility
export const toMomentUtc = toMomentInUserTz;
